module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("xiii")])]), _vm._v(" "), _c('p', {
    staticClass: "_toc",
    attrs: {
      "id": "_idParaDest-3"
    }
  }, [_vm._v("Contents"), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "toc-end-matter ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Acks#_idTextAnchor001"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-end-matter ParaOverride-2"
  }, [_c('a', {
    attrs: {
      "href": "#/SM#_idTextAnchor002"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SM1#_idTextAnchor003"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 1")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" To Do the Work  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM2#_idTextAnchor004"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 2")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" That’s Why It’s Called  “Practicing” Witchcraft  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM3#_idTextAnchor005"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 3")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Tools and Definitions  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM4#_idTextAnchor006"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 4")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Natural Born  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM5#_idTextAnchor007"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 5")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Preparation Techniques  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM6#_idTextAnchor008"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 6")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Grounding  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM7#_idTextAnchor009"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 7")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Energy and Execution  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM8#_idTextAnchor010"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 8")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Protection and Pushback  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM9#_idTextAnchor011"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 9")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Living as a Witch  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-chapters ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM10#_idTextAnchor012"
    }
  }, [_c('span', {
    staticClass: "semi"
  }, [_vm._v("Chapter 10")])]), _c('span', {
    staticClass: "semi"
  }, [_vm._v(":")]), _vm._v(" Some Simple Workings  ")]), _vm._v(" "), _c('p', {
    staticClass: "toc-end-matter ParaOverride-1"
  }, [_c('a', {
    attrs: {
      "href": "#/SM11#_idTextAnchor013"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Conclusion")])]), _c('span', {
    staticClass: "ital"
  }, [_vm._v(": A Permission Slip You Don’t Need  ")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-end-matter ParaOverride-3"
  }, [_c('a', {
    attrs: {
      "href": "#/SM12#_idTextAnchor014"
    }
  }, [_c('span', {
    staticClass: "ital"
  }, [_vm._v("Bibliography")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4eb868e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0